import React from 'react';
import { IonIcon, IonButton } from '@ionic/react';
import { close } from 'ionicons/icons';
import Modal from './Modal';
import './LoreBotChatActivityModal.css';

interface LoreBotChatActivityModalProps {
  /** Whether the modal is open */
  isOpen: boolean;
  /** Callback fired when modal should close */
  onClose: () => void;
  /** Additional CSS class name */
  className?: string;
  /** Partner doing business as */
  partnerDoingBusinessAs: string;
}

function LoreBotChatActivityModal({
  isOpen,
  onClose,
  className = '', 
  partnerDoingBusinessAs,
}: LoreBotChatActivityModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={className}
    >
      <div className="lorebot-chat-activity-modal-content">
        <IonButton onClick={onClose} className="lorebot-chat-activity-modal-close-button">
          <IonIcon icon={close} />
        </IonButton>
        <p className="lorebot-chat-activity-modal-heading">
          What This Does:
        </p>
        <p className="lorebot-chat-activity-modal-text">
          This lets you control if your <strong>Exploration Topics</strong>, <strong>Chat Summaries</strong>, and <strong>Chat Topics</strong> are available to {partnerDoingBusinessAs}.</p>
        <p className="lorebot-chat-activity-modal-heading">
          Why This Matters!
        </p>
        <p className="lorebot-chat-activity-modal-text">
          If this setting is turned on, then it could reveal sensitive information about your activity in Lore to {partnerDoingBusinessAs}.</p>
      </div>
    </Modal>
  );
}

export default LoreBotChatActivityModal;

